import React, { useEffect } from 'react';
import * as ReactGA from 'react-ga';

// Components
import { Button } from '../../components/Button';
import { Layout } from '../../components/Layout';

// i18n
import { useTranslation } from '../../translations/useTranslation';

// Context
import { useForm } from '../../context/form-context/hooks';
import { setFormScene } from '../../context/form-context/actions';

export const TooOldView: React.FC = () => {
  const { state, dispatch } = useForm();
  const { t, keys, locale } = useTranslation();

  // useEffect(() => {
  //   let eventArgs: ReactGA.EventArgs = {
  //     category: 'Medlemsansökan',
  //     action: 'User was to too old',
  //     nonInteraction: true,
  //   };

  //   if (state.userAge) {
  //     eventArgs['value'] = state.userAge;
  //   }

  //   ReactGA.event(eventArgs);
  // }, []);

  const handleOnGoBack = () => {
    if (dispatch) {
      dispatch(setFormScene('START'));
    }
  };

  if (locale === 'en') {
    <Layout viewId={'too-old'}>
      <div className="flex flex-column gap-2xs">
        <h1 className="text-2xl">{t(keys.headingGreeting)}</h1>
        <p>
          <strong>Only those under the age of 66 can join an a-kassa.</strong>{' '}
          Those aged 66 or over are eligible to apply for their pensions if they
          lose their work. There are ongoing discussions about raising the age
          limit for membership, but no decision has been reached.
        </p>
        <p>
          Best regards,
          <br /> Akademikernas a-kassa
        </p>
      </div>
      <Button className="margin-top-2xs" title={t(keys.uiButtonBack)} onClick={handleOnGoBack} />
    </Layout>;
  }

  return (
    <Layout viewId={'too-old'}>
      <div className="flex flex-column gap-2xs">
      <h1 className="text-2xl">{t(keys.headingGreeting)}</h1>
        <p>
          <strong>
            För att få gå med i a-kassan måste man vara yngre än 66 år.
          </strong>{' '}
          Skulle man bli arbetslös när man har fyllt 66 år kan man ta ut sin
          pension. Det förs diskussioner om att höja åldern för inträde, men
          inget finns beslutat.
        </p>
        <p>
          Vänliga hälsningar,
          <br /> Akademikernas a-kassa
        </p>
      </div>
      <Button className="margin-top-2xs" title={t(keys.uiButtonBack)} onClick={handleOnGoBack} />
    </Layout>
  );
};
